// Complete bank payment

const CORRECT_USERNAME = 'rapyd';
const CORRECT_PASSWORDS = ['success', 'error'];

export const SUCCESS_CREDENTIALS_PAYMENT = {
  param1: CORRECT_USERNAME,
  param2: CORRECT_PASSWORDS[0]
};

export const ERROR_CREDENTIALS_PAYMENT = {
  param1: CORRECT_USERNAME,
  param2: CORRECT_PASSWORDS[1]
};

// Complete bank redirect

const CORRECT_IBANS = ['xxxxxxxxxxxxxxxxrapydsuccess', 'xxxxxxxxxxxxxxxxxxxrapyderror'];
const CORRECT_OTP = '1234';

export const SUCCESS_CREDENTIALS_REDIRECT = {
  param1: CORRECT_IBANS[0],
  param2: CORRECT_OTP
};

export const ERROR_CREDENTIALS_REDIRECT = {
  param1: CORRECT_IBANS[1],
  param2: CORRECT_OTP
};
